import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { AppBar, Box, Hidden, IconButton, Toolbar, makeStyles, SvgIcon } from '@material-ui/core'
import { Menu as MenuIcon } from 'react-feather'
import Logo from '../../../components/Logo'
import { THEMES } from '../../../constants'
import Account from './Account'
import Settings from './Settings'

const useStyles = makeStyles(theme => ({
    root: {
        zIndex: theme.zIndex.drawer + 100,
        ...(theme.name === THEMES.LIGHT
            ? {
                  boxShadow: 'none',
                  backgroundColor: theme.palette.primary.main
              }
            : {}),
        ...(theme.name === THEMES.DARK
            ? {
                  backgroundColor: theme.palette.background.default
              }
            : {})
    },
    toolbar: {
        minHeight: 64,
        [theme.breakpoints.down('md')]: {
            paddingLeft: theme.spacing(1.5)
        },
        [theme.breakpoints.down('sm')]: {
            paddingLeft: theme.spacing(1)
        }
    }
}))

function TopBar({ className, onMobileNavOpen, ...rest }) {
    const classes = useStyles()

    return (
        <AppBar className={clsx(classes.root, className)} {...rest}>
            <Toolbar className={classes.toolbar}>
                <Hidden lgUp>
                    <IconButton className={classes.menuButton} color="inherit" onClick={onMobileNavOpen}>
                        <SvgIcon fontSize="small">
                            <MenuIcon />
                        </SvgIcon>
                    </IconButton>
                </Hidden>
                <Hidden mdDown>
                    <RouterLink to="/">
                        <Logo margin="0" maxwidth={200} />
                    </RouterLink>
                </Hidden>
                <Hidden lgUp>
                    <RouterLink to="/">
                        <Logo margin="0 0 0 10px" maxwidth={165} ismobile={1} />
                    </RouterLink>
                </Hidden>
                <Box ml={2} flexGrow={1} />
                <Settings />
                <Box ml={2}>
                    <Account />
                </Box>
            </Toolbar>
        </AppBar>
    )
}

TopBar.propTypes = {
    className: PropTypes.string,
    onMobileNavOpen: PropTypes.func
}

export default TopBar
